var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6364 24.6364C36.9879 24.2849 36.9879 23.7151 36.6364 23.3636L30.9088 17.636C30.5574 17.2846 29.9875 17.2846 29.636 17.636C29.2846 17.9875 29.2846 18.5574 29.636 18.9088L34.7272 24L29.636 29.0912C29.2846 29.4426 29.2846 30.0125 29.636 30.364C29.9875 30.7154 30.5574 30.7154 30.9088 30.364L36.6364 24.6364ZM12 24.9H36V23.1H12V24.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightIcon);
export default __webpack_public_path__ + "static/media/whiteRightIcon.d99f28ea759d40fb14e4e6149dc82400.svg";
export { ForwardRef as ReactComponent };